import { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { SidebarBoxKey } from 'AdmissionsGuidance/StudentDashboard.types';
import { getProgramApplication } from 'Users';
import { useCurrentUser, useNavigationHelper } from 'FrontRoyalAngular';
import { ImportantCtaBox } from '../../ImportantCtaBox';
import { BasicMobileBox } from '../../BasicMobileBox';

function ScheduleYourInterviewBoxComponent({ mobile }: { mobile?: boolean }) {
    const currentUser = useCurrentUser();
    const { loadUrl } = useNavigationHelper();
    const programApplication = useMemo(() => (currentUser ? getProgramApplication(currentUser) : null), [currentUser]);
    const onPressCta = useCallback(() => {
        const interviewUrl = programApplication?.invitedToInterviewUrl;
        if (!interviewUrl) return;
        loadUrl(interviewUrl, '_blank');
    }, [loadUrl, programApplication]);
    return mobile ? (
        <ScheduleYourInterviewBoxMobilePresentation onPressCta={onPressCta} />
    ) : (
        <ScheduleYourInterviewBoxPresentation onPressCta={onPressCta} />
    );
}

function ScheduleYourInterviewBoxPresentation({ onPressCta }: { onPressCta: () => void }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'scheduleYourInterviewBox' });
    return (
        <ImportantCtaBox
            headerTitle={t('headerTitle')}
            headerSubtitle={t('headerSubtitle')}
            boxKey={SidebarBoxKey.schedule_your_interview}
            ctaText={t('ctaText')!}
            onPressCta={onPressCta}
        >
            {t('content')}
        </ImportantCtaBox>
    );
}

function ScheduleYourInterviewBoxMobilePresentation({ onPressCta }: { onPressCta: () => void }) {
    const { t } = useTranslation('back_royal', { keyPrefix: 'scheduleYourInterviewBox' });
    return (
        <BasicMobileBox
            heading={t('mobileContent')}
            boxKey={SidebarBoxKey.schedule_your_interview}
            buttonId="cta"
            ctaText={t('mobileCtaText')!}
            onPress={onPressCta}
        />
    );
}

export const ScheduleYourInterviewBox = memo(ScheduleYourInterviewBoxComponent);
